<template>
  <div class="component-notazz">
    <h4 class="text-semibold mb-5">Notazz</h4>
    <snow-data-table-header
      class="mb-6"
      @add="add"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block my-9 mx-auto"
              src="@/assets/images/no-content.svg"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <snow-data-table
        v-else
        :columns="InvoicesColumns"
        :data="integrationList"
      />
      <!-- Mobile area -->
      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
    <notazz-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
    />
  </div>
</template>
<script>
import NotazzModal from "@/components/tools/modals/Notazz.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import { mapState } from "vuex";
export default {
  mixins: [IntegrationsMixin],
  components: {
    NotazzModal
  },
  data() {
    return {
      loading: false,
      integrationToEdit: null,
      modal: false,
      integration: "notazz",
      search: "",
      invoiceType: {
        nfse: "Nota fiscal de serviço",
        nfe_55: "Nota fiscal de produto"
      }
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    ...mapState("integration", ["integrationList", "pagination"]),
    ...mapState("product", ["products"]),
    InvoicesColumns() {
      return [
        {
          name: "Produto",
          field: "product_name"
        },
        {
          name: "Descrição",
          field: "description"
        },
        {
          name: "Token",
          field: "token"
        },
        {
          name: "Tipo de nota",
          field: "type",
          transform: (value, item) => {
            if (item.is_split) {
              return `NFE: ${item.nfe_tax}% - NFSE: ${item.nfse_tax}%`;
            }
            return this.invoiceType[value] || "Split de notas";
          }
        },
        {
          name: "Status",
          field: "status",
          transform: value => (value ? "Ativo" : "Inativo"),
          color: value => (value ? "green" : "negative"),
          type: "tag"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    dispatch() {
      let params = {};

      if (this.search) {
        params = { search: this.search };
      }

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getActions(item) {
      return [
        {
          label: item.status ? "Desativar" : "Ativar",
          class: item.status ? "text-danger" : "text-success",
          click: this.changeStatus
        },
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir integração",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Deseja mesmo excluir esta integração?",
            buttonText: "Confirmar",
            secondaryButtonText: "Cancelar",
            icon: "ph ph-trash",
            action: this.submitDelete
          }
        }
      ];
    },
    changeStatus(item) {
      let data = {
        id: item.id,
        product_id: item.product_id,
        status: !item.status
      };
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
          this.dispatch();
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    }
  }
};
</script>
